import { configure } from 'utils/configure';

export const normalizeReturnUrl = (url = '', defaultUrl = '/'): string => {
  if (!url) {
    return defaultUrl;
  }

  if (url.startsWith('/')) {
    return url;
  }

  if (url.startsWith(configure.serviceUrl)) {
    return url;
  }

  if (url.startsWith('https://dirittohelp.zendesk.com/')) {
    return url;
  }

  if (url.startsWith('https://help.diritto.co.kr/')) {
    return url;
  }

  return defaultUrl;
};
